// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2iTll","title":"Info_title__1npEK","links":"Info_links__2czfR","link":"Info_link__3ZTss","logo":"Info_logo__3vaVQ"};